"use client";

import { useMemo } from "react";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { useUnassignDialog } from "../Providers/UnassignDialogContext";

const columns: GridColDef[] = [
  {
    field: "email",
    headerName: "Email",
    width: 300,
    flex: 1,
  },
];

export default function UsersDataGrid() {
  const { usersToUnassign, userRowSelectionModel, setUserRowSelectionModel } =
    useUnassignDialog();

  // Convert users to rows with id field for DataGrid
  const rows = useMemo(
    () =>
      usersToUnassign.map((user) => ({
        id: user.id,
        email: user.email,
      })),
    [usersToUnassign],
  );

  return (
    <DataGridPro
      checkboxSelection
      columns={columns}
      disableColumnFilter
      disableColumnMenu
      disableColumnSelector
      disableRowSelectionOnClick
      rows={rows}
      rowSelectionModel={userRowSelectionModel}
      onRowSelectionModelChange={setUserRowSelectionModel}
      hideFooter
      autoHeight
    />
  );
}
